import { environment } from '../../../../environments/environment'
import type { Query } from '../../rest/types/query'
import { AuthenticationMethod } from '../enums/authentication-method'
import { ManagerVersion, parseVersion } from '../types/manager-version'

export class EnvUtilities {
  public static isProduction(): boolean {
    return environment.production
  }

  public static environment(): string {
    return environment.environment
  }

  public static rawVersion(): string {
    return environment.version
  }

  public static buildVersion(): ManagerVersion {
    return parseVersion(EnvUtilities.rawVersion())
  }

  public static authMethods(): AuthenticationMethod[] {
    return environment.authMethods
      .split('|')
      .map(
        (value) =>
          AuthenticationMethod[value as keyof typeof AuthenticationMethod]
      )
  }

  public static inputDebounceTime(): number {
    return environment.inputDebounceTime
  }

  public static browserWaitTime(): number {
    return environment.browserWaitTime
  }

  public static sentryDSN(): string {
    return environment.sentryDSN
  }

  public static invoicingCutOff(): Date {
    return environment.invoicingCutOff
  }

  public static echoConfig() {
    return environment.echo
  }

  public static reverbConfig() {
    return environment.reverb
  }

  public static serviceUrl(
    path: string,
    api: string | null = 'manage',
    query?: Query
  ): string {
    return `${environment.serviceUrl}/${api ? `${api}/` : ''}${path}${query ? `${query.toString()}` : ''}`
  }

  public static routeUrl(
    path: string,
    params?: Record<string, unknown>,
    query?: Query
  ): string {
    let parameterised = path
    if (params) {
      for (const param of Object.keys(params)) {
        parameterised = parameterised
          .replace(`{${param}?}`, `${params[param]}`)
          .replace(`{${param}}`, `${params[param]}`)
      }
    }
    return this.serviceUrl(parameterised, null, query)
  }
}
